import * as React from 'react';
import { observer } from 'mobx-react';

// types
import { NativeColorMode } from '../../../../widgets/PostsWidget/types';
import { NativeTitleProps } from './types';

// components
import { StyledNativeTitle } from './styledComponents';

const EMOJI_DEFAULT = {
    platform: 'default',
};

const NativeTitle: React.FC<NativeTitleProps> = ({
    title,
    lineClamp,
    maxCharacters = 200,
    emoji = EMOJI_DEFAULT,
    colorMode = 'light' as NativeColorMode,
}) => {
    return (
        <StyledNativeTitle
            emoji={emoji}
            lineClamp={lineClamp}
            colorMode={colorMode}
            data-id='native-title'
            noGrow
            maxCharacters={maxCharacters}
            size={'l'}>
            {title}
        </StyledNativeTitle>
    );
};

NativeTitle.displayName = 'NativeTitle';
export default observer(NativeTitle);
